/* eslint-disable @typescript-eslint/naming-convention */
import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    isHTML: boolean;
    title: string;
    value: string;
}

export const DetailedDescriptionItem: FC<IProps> = ({isHTML, title, value}) => {
    return (
        <div className={style.main}>
            <Typography variant={'title-18-m'}>{title}</Typography>
            {isHTML ? (
                <div className={style.htmlContainer} dangerouslySetInnerHTML={{__html: value}} />
            ) : (
                <Typography variant={'body-16-r'}>{value}</Typography>
            )}
        </div>
    );
};
